// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import ScoutPreviewController from './scout_preview_controller';
import ScoutOfferSelectModalController from './scout_offer_select_modal_controller';
import ScoutOfferSelectModalV2Controller from './scout_offer_select_modal_v2_controller';
import ScoutOfferCardController from './scout_offer_card_controller';
import ScoutFormContainerController from './scout_form_container_controller';
import ScoutTemplateModalController from './scout_template_modal_controller';
import ScoutTemplateModalV2Controller from './scout_template_modal_v2_controller';
import ScoutTemplateModalV3Controller from './scout_template_modal_v3_controller';
import ScoutTemplateFormController from './scout_template_form_controller';
import ScoutTemplateFormV2Controller from './scout_template_form_v2_controller';
import ScoutTemplateFormV3Controller from './scout_template_form_v3_controller';
import ScoutHistoryFormController from './scout_history_form_controller';
import UneditScoutTemplateModalController from './unedit_scout_template_modal_controller';
import UneditScoutTemplateFormController from './unedit_scout_template_form_controller';
import PhaseChangeAlertController from './phase_change_alert_controller';
import PartTimeRewardAlertController from './part_time_reward_alert_controller';
import BannerRotatorController from './banner_rotator_controller';
import SidebarController from './sidebar_controller';

application.register('scout-preview', ScoutPreviewController);

application.register(
    'scout-offer-select-modal',
    ScoutOfferSelectModalController
);

application.register(
    'scout-offer-select-modal-v2',
    ScoutOfferSelectModalV2Controller
);

application.register('scout-offer-card', ScoutOfferCardController);

application.register('scout-form-container', ScoutFormContainerController);

application.register('scout-template-modal', ScoutTemplateModalController);

application.register('scout-template-modal-v2', ScoutTemplateModalV2Controller);

application.register('scout-template-modal-v3', ScoutTemplateModalV3Controller);

application.register('scout-template-form', ScoutTemplateFormController);

application.register('scout-template-form-v2', ScoutTemplateFormV2Controller);

application.register('scout-template-form-v3', ScoutTemplateFormV3Controller);

application.register('scout-history-form', ScoutHistoryFormController);

application.register(
    'unedit-scout-template-modal',
    UneditScoutTemplateModalController
);

application.register(
    'unedit-scout-template-form',
    UneditScoutTemplateFormController
);

application.register('phase-change-alert', PhaseChangeAlertController);

application.register('part-time-reward-alert', PartTimeRewardAlertController);

application.register('banner-rotator', BannerRotatorController);

application.register('sidebar', SidebarController);
